export const isKeyboardEvent = event => event && event.screenX == 0 && event.screenY == 0;
